import posthog from 'posthog-js'

// PostHog API keys are publishable and safe to hardcode (they can only send data, not read it)
const ENABLE_IN_DEV = false // Set to true to test PostHog locally

export const initPostHog = () => {
  // Only initialize in production or when explicitly enabled in dev
  const isProduction = import.meta.env.PROD
  
  if (!isProduction && !ENABLE_IN_DEV) {
    console.log('📊 PostHog disabled in development')
    return
  }

  const apiKey = 'phc_HFuM4TEi2cm5hfbrPiTUlIPBG7iM2nV7wanz8IGLBrm'
  const apiHost = 'https://eu.posthog.com'

  posthog.init(apiKey, {
    api_host: apiHost,
    
    // Privacy & GDPR compliance
    opt_out_capturing_by_default: false,
    respect_dnt: true,
    
    // Session replay settings
    session_recording: {
      recordCrossOriginIframes: false,
      maskAllInputs: true,
      maskTextSelector: '.sensitive-data',
    },
    
    // Autocapture settings
    autocapture: {
      dom_event_allowlist: ['click', 'submit'],
      url_allowlist: ['leap.momentumlab.earth'],
      element_allowlist: ['button', 'a'],
    },
    
    // Performance
    loaded: (posthog) => {
      if (import.meta.env.DEV) {
        console.log('✅ PostHog initialized:', posthog)
      }
    },
    
    // Disable features you don't need
    disable_session_recording: false, // ✅ Enabled for UX optimization (2025-01)
    disable_surveys: true,
    
    // Cross-domain tracking
    cross_subdomain_cookie: false,
    
    // Persistence
    persistence: 'localStorage+cookie',
  })
}

export { posthog }
